import React, { Component } from 'react';
import cn from 'classnames';

import QuickChangeMdnModal from '../modals/ChangeMdnModal/quick';

class ChangeMdnButton extends Component {
  state = {
    isOpen: false,
  };

  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  render() {
    const { purchaseId, userId } = this.props;
    const { isOpen } = this.state;
    return (
      <React.Fragment>
        <button className={cn('btn', 'btn-default')} onClick={this.openModal}>
          Change MDN
        </button>
        <QuickChangeMdnModal
          userId={userId}
          purchaseId={purchaseId}
          isOpen={isOpen}
          closeModal={this.closeModal}
        />
      </React.Fragment>
    );
  }
}

export default ChangeMdnButton;
